import { render, staticRenderFns } from "./EcommerceStatusBadge.vue?vue&type=template&id=6de745e3&scoped=true"
import script from "./EcommerceStatusBadge.vue?vue&type=script&lang=js"
export * from "./EcommerceStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./EcommerceStatusBadge.vue?vue&type=style&index=0&id=6de745e3&prod&lang=scss&scoped=true"
import style1 from "./EcommerceStatusBadge.vue?vue&type=style&index=1&id=6de745e3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de745e3",
  null
  
)

export default component.exports